module.exports = __webpack_public_path__ + "img/banner-partner.03418d17.png";